module.exports = __webpack_public_path__ + "static/media/P14.865c2752.png";